import { render, staticRenderFns } from "./ColumnReceiptActions.vue?vue&type=template&id=49502e20"
import script from "./ColumnReceiptActions.vue?vue&type=script&lang=js"
export * from "./ColumnReceiptActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports